// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"3fe0ff5b","477":"8cc4f8ce","583":"06406d52","756":"eee8dec7"}[chunkId] + ".chunk.js";
};